<div class="card m-0 shadow-none">
  <div class="card-header">
    <div class="row align-items-center">
      <div class="col">
        <h5 class="m-0">Download Engagement Plan</h5>
      </div>
      <div class="col-auto">
        <button
          type="button"
          class="btn p-2"
          (click)="modal.dismiss('Cross click')">
          <i class="bx bx-x font-size-24"></i>
        </button>
      </div>
    </div>
  </div>
  <div class="card-body">
    <div class="row">
      <div class="col-12 mb-3">
        <h6>Internal</h6>
        <p>Includes friend matches with resident photos & common interests.</p>
        <button
          type="button"
          class="btn btn-primary btn-xl w-100"
          (click)="download('internal')">
          <i class="bx bx-download"></i> Download {{ month }} Plan
        </button>
      </div>

      <div class="col-12 mb-3">
        <h6>External</h6>
        <p>
          Includes # of friend matches and common interests. No other resident
          info is included.
        </p>
        <button
          type="button"
          class="btn btn-info btn-xl w-100"
          (click)="download('external')">
          <i class="bx bx-download"></i>
          Download {{ month }} Plan
        </button>
      </div>

      <div class="col-12">
        <div
          class="alert alert-light d-flex align-items-center gap-2 mb-4"
          role="alert">
          <i
            class="bx bx-info-circle bx-align-middle align-middle font-size-24"></i>
          <div>
            Download past plans in the <b>Engagement Plans</b> section below the
            assessments section on the resident profile.
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
